import {t} from "i18next";
import {toast} from "react-toastify";
import Cookies from "universal-cookie";
import {useAuth} from "@/hooks/useAuth";

const Circles = ({data, onAssistantOpen}) => {
	const {isAuthenticated} = useAuth();

	const handleClick = () => {
		if (data.id === 9) {
			onAssistantOpen();
			return;
		}

		if (data.href === "/") {
			toast.info(t("CONSTANTS.COMING_SOON"));
			return;
		}

		if (data.authenticationRequired && !isAuthenticated) {
			new Cookies().set("authRequired", true, {path: '/'});
			window.open('/login', '_self');
		} else {
			window.open(data.href, '_blank');
		}
	};

	return (
		<button
			onClick={handleClick}
			className="w-[50vw] md:mt-5 mt-10 flex flex-col justify-center items-center"
		>
			<img
				src={data.img}
				alt={data.title}
				className="w-full aspect-square object-contain shadow-2xl rounded-full"
			/>
			<h1 className="font-custom-bold text-lg text-center mt-4 text-red-800">
				{data.title}
			</h1>
		</button>
	);
};

export default Circles;
